
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integrations/manhattan",
      function () {
        return require("private-next-pages/integrations/manhattan.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/integrations/manhattan"])
      });
    }
  